import React from "react";
import { QRCodeSVG } from "qrcode.react";

const SITE_URL = "https://flexlines.store";

/**
 * Compact QR code that deep-links to the live Flex Line site.
 * Rendered across the app so customers can scan and open it on mobile.
 */
export function QRBadge({ url = SITE_URL, label = "Scan to open on your phone", size = 96 }) {
    return (
        <div
            className="flex items-center gap-3 border border-[#DDD6FE] rounded-sm bg-paper p-3"
            data-testid="qr-badge"
        >
            <div className="bg-white p-1.5 rounded-sm shrink-0">
                <QRCodeSVG value={url} size={size} level="M" fgColor="#4C1D95" bgColor="#ffffff" />
            </div>
            <div className="min-w-0">
                <p className="font-mono text-[10px] uppercase tracking-wider text-zinc-500">Flex Line</p>
                <p className="text-sm font-medium leading-tight mt-0.5">{label}</p>
                <p className="font-mono text-[11px] text-emerald-deep truncate mt-0.5">flexlines.store</p>
            </div>
        </div>
    );
}

export default QRBadge;
